import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const getPermanentlyHidden = () =>
  typeof localStorage !== "undefined" && localStorage.getItem("hideGettingStarted") === "true";

const initialState: {
  open: boolean;
  permanentlyHidden: boolean;
} = {
  open: false,
  permanentlyHidden: getPermanentlyHidden(),
};

const slice = createSlice({
  name: "SetupChecklistDrawer",
  initialState,
  reducers: {
    setSetupChecklistDrawerOpen(state, action: PayloadAction<boolean>) {
      state.open = action.payload;
    },
    setSetupChecklistPermanentlyHidden(state, action: PayloadAction<boolean>) {
      state.permanentlyHidden = action.payload;
    },
  },
});

export const { setSetupChecklistDrawerOpen, setSetupChecklistPermanentlyHidden } = slice.actions;

export default slice.reducer;
